const id = {
  '赞助和游戏责任': 'Tanggung Jawab Sponsorship dan Permainan',
'产品': 'Produk',
'游戏': 'Permainan',
"announcement": 'Masuki sensasi dan rasakan kegembiraan permainan online kami hari ini! Jelajahi dunia peluang di mana kesenangan dan hadiah hanya selangkah lagi!',
'排名': 'Peringkat',
"更多的": "Lebih Banyak",
"拱廊": "Arcade",
"撞车游戏": "Permainan Kecelakaan",
"钓鱼游戏": "Permainan Memancing",
"直播": "Live",
"登录": "Masuk",
"注册": 'Daftar',
"选择语言": 'Bahasa',
"介绍人": "Pengantar",
"账号": "Akun",
"密码": "Kata Sandi",
"确认密码": "Konfirmasi Kata Sandi",
"真实姓名": "Nama",
"手机号码": "Nomor Telepon",
"取款密码": "Kata Sandi Penarikan",
"验证码": "Kode",
"请输入密码": "Silakan masukkan kata sandi",
"请输入验证码": "Silakan masukkan kode verifikasi",
"请输入账号": "Silakan masukkan akun",
"请重新获取验证码": "Silakan ambil kode verifikasi lagi",
"正在登录中": "Sedang masuk",
"网络异常,请稍后再试": "Kesalahan jaringan, silakan coba lagi nanti",
"账号名": "Nama Akun",
"余额": "Saldo",
"会员中心": "Anggota",
"网上存款": "Setoran Online",
"网上提款": "Penarikan Online",
"退出": "Keluar",
"请再次输入密码": "Silakan masukkan kata sandi lagi",
"请输入姓名": "Silakan masukkan nama Anda",
"请输入手机号": "Silakan masukkan nomor telepon Anda",
"请输入取款密码": "Silakan masukkan kata sandi penarikan",
"正在注册中": "Sedang mendaftar",
"确定": "Tentukan",
"注册成功": "Pendaftaran berhasil",
"热门优惠": "Diskon Populer",
"首页": "Beranda",
"查看活动": "Lihat Kegiatan",
"正在获取活动列表": "Mengambil daftar kegiatan",
"暂无活动": "Tidak ada kegiatan saat ini",
"活动详情": "Rincian Acara",
"视讯直播": "Streaming Video Langsung",
"直播类型": "Jenis Streaming Langsung",
"热门": "Populer",
"推荐": "Rekomendasi",
"最新": "Terbaru",
"全部": "Semua",
"获取类型中": "Mengambil jenis",
"获取具体信息中": "Mengambil informasi spesifik",
"开始": "Mulai",
"正在获取资源": "Mengakuisisi sumber daya",
"正在努力加载中": "Sedang berusaha memuat",
"电子": "Elektron",
"大厅": "Ruang Utama",
"游戏类型": "Jenis Permainan",
"游戏标签": "Label Permainan",
"错误的类型": "Jenis Salah",
"返回首页": "Halaman Utama",
"正在获取游戏列表": "Mengambil daftar permainan",
"暂无游戏": "Saat ini tidak ada permainan yang tersedia",
"当前未登录,请先登录": "Saat ini tidak masuk, silakan masuk terlebih dahulu",
"联系我们": "Hubungi Kami",
"导航": "Navigasi",
"配置文件信息": "Informasi Profil",
"常用功能": "Fungsi Umum",
"充值": "Isi Ulang",
"提现": "Penarikan",
"功能列表": "Fungsi",
"交易": "Transaksi",
"设置": "Pengaturan",
"修改登入密码": "Ubah kata sandi masuk",
"修改提现密码": "Ubah kata sandi penarikan",
"银行卡": "Kartu Bank",
"若您先前透由手机号或社交平台登录站点，请您直接联系客服协助设置": "Jika Anda sebelumnya masuk ke situs melalui nomor telepon atau platform media sosial, silakan hubungi layanan pelanggan langsung untuk membantu pengaturannya",
"旧密码": "Kata Sandi Lama",
"请输入旧密码": "Silakan masukkan kata sandi lama Anda",
"设定新密码": "Atur kata sandi baru",
"确认新密码": "Konfirmasi kata sandi baru",
"确认": "Konfirmasi",
"下一步": "Langkah Selanjutnya",
"交易功能": "Fungsi Perdagangan",
"支付方式": "Metode Pembayaran",
"充值教学": "Pengajaran Isi Ulang",
"选择渠道": "Pilih Saluran",
"存款金额": "Setoran",
"实际金额": "Jumlah Aktual",
"提现币种": "Mata Uang Penarikan",
"提现银行卡": "Kartu Bank untuk Penarikan",
"新增": "Baru Ditambahkan",
"提现金额": "Jumlah Penarikan",
"提现金额范围": "Rentang Jumlah Penarikan",
"请输入金额": "Silakan masukkan jumlah",
"实际到帐": "Penerimaan Aktual",
"一般手续费": "Biaya Administrasi Umum",
  "强制手续费": "Biaya penanganan wajib",
"上一步": "Kembali",
"修改成功": "Berhasil dimodifikasi",
"修改中": "Sedang dimodifikasi",
"拼命加载中": "Sedang memuat dengan sangat cepat",
"编辑登录密码": "Edit kata sandi masuk",
"编辑提款密码": "Edit kata sandi penarikan",
"如果您通过手机号码或社交平台登录网站，请联系向客户服务部门寻求帮助。": "Jika Anda masuk ke situs melalui nomor telepon atau platform media sosial, silakan hubungi layanan pelanggan untuk bantuan.",
"请输入新密码": "Silakan masukkan kata sandi baru",
"新密码不能和旧密码一致": "Kata sandi baru tidak boleh sama dengan kata sandi lama",
"两次输入密码不一致!": "Dua kata sandi yang dimasukkan tidak cocok!",
"请输入提款密码": "Silakan masukkan kata sandi penarikan",
"输入提款密码": "Masukkan kata sandi penarikan",
"请设置新的提款密码": "Silakan atur kata sandi penarikan baru",
"设置6位提款密码，并记住您的密码": "Atur kata sandi penarikan 6 digit dan ingat kata sandi Anda",
"请输入新的提款密码": "Silakan masukkan kata sandi penarikan baru",
"存款": "Setoran",
"取款": "Penarikan",
"付款方式": "Metode Pembayaran",
"存款金额": "Jumlah Setoran",
"请输入金额": "Silakan masukkan jumlah",
"下一步": "Langkah Selanjutnya",
"提款金额": "Jumlah Penarikan",
"提款银行卡": "Kartu Bank Penarikan",
"请输入您的银行卡号": "Silakan masukkan nomor kartu bank Anda",
"切换语言将会刷新页面": "Mengganti bahasa akan menyegarkan halaman",
"充值方式": "Metode Isi Ulang",
"取消": "Pembatalan",
"登录过期,是否重新登录": "Login telah kedaluwarsa, apakah Anda ingin masuk kembali?",
"系统提示": "Pemberitahuan sistem",
"国家": "Negara",
"请输入": "Silakan masukkan",
"请选择": "Silakan pilih",
"please-select-method": "Silakan pilih metode pembayaran",

// 新的一套
"加载更多": "Muat lebih banyak",
"开始": "Mainkan",
// "存取款": "Setoran/Penarikan",
"存取款": "Setoran",
"加钱": "Tambah uang",
"选择您的奖金": "Pilih bonus Anda",
"100%,最高1500": "100% hingga R$1.500",
"CASINO": "KASINO",
"Select your lottery": "Pilih lotere Anda",
"don't want a lottery": "tidak ingin lotere",
"金额不得小于": "Jumlah tidak boleh kurang dari",
"金额不得大于": "Jumlah tidak boleh lebih dari",
"加载失败": "Muat Gagal",
"活动中心": "Pusat Aktivitas",
"**财富攀升-BRL的充值促销**": "**Panjat Kekayaan - Promosi Isi Ulang dalam BRL**",
"在这个独特的活动中，我们为您提供了一个积累财富的无尽机会。无论你是初学者还是老手，每次充值都会为你带来不同级别的礼物以及更高级别的特权。": "Dalam acara unik ini, kami memberikan Anda kesempatan tanpa akhir untuk mengumpulkan kekayaan. Baik Anda pemula maupun pengguna berpengalaman, setiap isi ulang akan memberi Anda berbagai tingkat hadiah dan hak istimewa yang lebih tinggi.",
"**青铜级别（青铜）**": "**Tingkat Perunggu (Bronze)**",
"-重新加载的总金额：1.000-5.000 BRL": "- Jumlah total yang diisi ulang: 1.000 - 5.000 BRL",
"-礼品的比例从5%逐渐增加到10%": "- Proporsi hadiah meningkat dari 5% hingga 10%",
"-第一次充值时，您将收到一份专属礼物。通往财富的大门是敞开的。每充值一次，就会收到更多的礼物。": "- Pada isi ulang pertama, Anda akan menerima hadiah eksklusif. Pintu menuju kekayaan terbuka. Setiap kali Anda melakukan isi ulang, lebih banyak hadiah akan datang.",
"**银级（银级）**": "**Tingkat Perak (Silver)**",
"-重新加载的总金额：5.001-15.000 BRL": "- Jumlah total yang diisi ulang: 5.001 - 15.000 BRL",
"-礼品的比例从10%逐渐增加到15%": "- Proporsi hadiah meningkat dari 10% hingga 15%",
"-您已达到白银级别，您的财富将继续增长。充值越多，礼品比例就越高。重新加载更多，赚取更多！": "- Anda telah mencapai tingkat Perak di mana kekayaan Anda terus tumbuh. Semakin banyak Anda mengisi ulang, semakin tinggi proporsi hadiah. Isi ulang lebih banyak, dapatkan lebih banyak!",
"**黄金级别（Gold）**": "**Tingkat Emas (Gold)**",
"-重新加载的总金额：15.001-30.000 BRL": "- Jumlah total yang diisi ulang: 15.001 - 30.000 BRL",
"-礼品的比例从15%逐渐增加到18%": "- Proporsi hadiah meningkat dari 15% hingga 18%",
"-你正走在富有的贵族之路上。成为金牌会员后，您将收到更多慷慨的礼物。你的财富注定会兴旺发达。": "- Anda berada di jalur bangsawan yang kaya. Dengan menjadi anggota Emas, Anda akan menerima lebih banyak hadiah yang murah hati. Kekayaan Anda ditakdirkan untuk makmur.",
"**白金级别（白金）**": "**Tingkat Platinum (Platinum)**",
"-随着冷却值的增加，会奖励更多的礼物": "- Dengan meningkatnya nilai cooldown, lebih banyak hadiah akan diberikan",
"-重新加载的总金额：30.001-60.000 BRL": "- Jumlah total yang diisi ulang: 30.001 - 60.000 BRL",
"-礼品的比例从18%逐渐增加到20%": "- Proporsi hadiah meningkat dari 18% hingga 20%",
"-在白金级别，您的充值将获得更高比例的礼物。你的理财能力会变得更加卓越，并获得丰厚的回报。": "- Di tingkat Platinum, isi ulang Anda akan mendapatkan proporsi hadiah yang lebih tinggi. Kemampuan pengelolaan keuangan Anda menjadi lebih luar biasa, dengan imbalan yang melimpah.",
"**钻石级别（钻石）**": "**Tingkat Berlian (Diamond)**",
"-重新加载的总金额：60.001-100.000 BRL": "- Jumlah total yang diisi ulang: 60.001 - 100.000 BRL",
"-礼品比例最高，达到20%": "- Proporsi hadiah tertinggi, mencapai 20%",
"-这是荣誉的高度，是最终的选择。成为钻石会员后，您将享受最高比例的礼物，使您的财富加速增长，您的财务梦想即将实现。": "- Ini adalah puncak kehormatan, pilihan terakhir. Dengan menjadi anggota Berlian, Anda akan menikmati proporsi hadiah tertinggi, yang mempercepat pertumbuhan kekayaan Anda, dan impian finansial Anda akan segera terwujud.",
"不要错过这个难得的机会。攀登财富的阶梯，看着你的财富成倍增长。加入我们的“财富攀登”BRL补充促销活动，确保为实现您的财务目标提供最佳支持。财富之旅从你开始，回报不会停止增长，成功就在你身边！": `Jangan lewatkan kesempatan luar biasa ini. Panjat tangga kekayaan, saksikan kekayaan Anda berlipat ganda. Bergabunglah dengan promosi isi ulang BRL "Panjat Kekayaan" kami dan pastikan dukungan optimal untuk mencapai tujuan keuangan Anda. Perjalanan menuju kekayaan dimulai dengan Anda, imbalan tidak akan berhenti tumbuh, kesuksesan ada di sisi Anda!`,
"游戏记录": "Rekaman Permainan",
  "交易记录": "Rekaman transaksi",
  "提交": "Kirim",
  "游戏品牌": "Merek permainan",
  "游戏名称": "Nama permainan",
  "下注时间": "Waktu taruhan",
  "下注金额": "Jumlah taruhan",
  "输赢金额": "Jumlah kemenangan atau kerugian",
  "上一页": "Halaman sebelumnya",
  "下一页": "Halaman berikutnya",
  "申请时间": "Waktu permohonan",
  "状态": "Status",
  "法规与合作伙伴": "Peraturan dan Mitra",
  "为了注册本网站，用户必须接受一般条款和条件。如果条款和条件发生更新，现有用户可以选择在上述更新生效之前停止使用产品和服务，即在更新公布后至少两周。tambet911.com 由JajajEmmi B.V.运营，注册号为150790，地址为Abraham Mendez Chumaceiro Boulevard 03，Willemstad，Curacao。本网站由库拉索岛电子博彩公司许可和监管，许可证号为1668/JAZ。": "Untuk mendaftar di situs web ini, pengguna harus menerima syarat dan ketentuan umum. Jika syarat dan ketentuan diperbarui, pengguna yang ada dapat memilih untuk berhenti menggunakan produk dan layanan sebelum pembaruan yang disebutkan tersebut mulai berlaku, yaitu setidaknya dua minggu setelah pembaruan diumumkan. Tambet911.com dioperasikan oleh JajajEmmi B.V. dengan nomor registrasi 150790 dan alamatnya adalah Abraham Mendez Chumaceiro Boulevard 03, Willemstad, Curacao. Situs web ini dilisensikan dan diatur oleh Perusahaan Permainan Elektronik Curacao dengan nomor lisensi 1668/JAZ.",
  '您可以使用用户名和密码登录': 'Anda dapat masuk dengan nama pengguna dan kata sandi Anda',
  '创建账户': 'Buat akun',
  '银行信息': 'Informasi Bank',
  '名称': 'Nama',
  '时间': 'Waktu',
  '最小': 'Min',
  '最大': 'Max',
  '即时到账': 'Penerimaan Instan',
  '选择银行': 'Pilih Bank',
  '银行账号': 'Nomor rekening bank',
  '请输入银行账号': 'Silakan masukkan nomor rekening bank Anda',
  '金额': 'Jumlah',
  '支出': 'Pembayaran',
  '输入金额': 'Silakan masukkan jumlah',
  "暂无数据": "Saat ini tidak ada data yang tersedia",
  '获奖人': 'Pemenang',
  '游戏榜': 'Peringkat Permainan',
  '新游戏榜': 'Peringkat Permainan Baru',
  '热门游戏榜': 'Peringkat Permainan Populer',
  '电子游戏': 'Permainan Elektronik',
  '主要余额': 'Saldo utama',
  '历史记录': 'Riwayat',
  '付款名称': 'Nama Pembayaran',
  '费用': 'Biaya',
  '免费': 'Gratis',
  '立即生效': 'Efektif segera',
  '银行选择': 'Pilih Bank',
  '银行账户': 'Rekening bank',
  '充值金额': 'Jumlah pengisian ulang',
  '收款名称': 'Nama penerimaan',
  '账号类型': 'Tipe akun',
  '收账账号': 'Nomor rekening penerimaan',
  'CPF号码': 'Nomor CPF',
  '提现密码': 'Kata sandi penarikan',
  '请输入名称': 'Silakan masukkan nama',
  '请选择类型': 'Silakan pilih jenis',
  '请输入CPF': 'Silakan masukkan CPF',
  '请输入提现金额': 'Silakan masukkan jumlah penarikan',
  '请输入正确的参数': 'Silakan masukkan parameter yang benar',
  "收藏夹": "Favorit",
  "敬请期待": "Segera Hadir",
  "用户": "Pengguna",
  "玩家": "Pemain",
  "时间": "Waktu",
  "赌场": "Kasino",
  "体育运动": "Olahraga",
  "促销": "Promo",
  "支持/法律": "Dukungan/Hukum",
  "加入我们的社区": "Bergabunglah dengan Komunitas Kami",
  "赌场主页": "Beranda Kasino",
  "插槽": "Slot",
  "现场赌场": "Kasino Langsung",
  "新版本": "Rilisan Baru",
  "桌面游戏": "Permainan Meja",
  "体育之家": "Rumah Olahraga",
  "会员俱乐部": "Klub VIP",
  "优惠促销": "Promosi",
  "赌博意识": "Kesadaran Judi",
  "常问问题": "FAQ",
  "条款和条件": "Syarat dan Ketentuan",
  "隐私政策": "Kebijakan Privasi",
  "赞助和游戏责任": "Sponsor dan Tanggung Jawab Permainan",
  "页脚文本": "BetBlitz berusaha untuk mencapai dominasi global dalam dunia permainan dan taruhan online, memanfaatkan teknologi blockchain mutakhir, dan dengan tegas memprioritaskan kepuasan pelanggan. Di pusat operasi kami terletak prinsip kepercayaan, integritas, dan keadilan, yang membimbing setiap usaha kami.",
  "充电时间": "Waktu Pengisian Ulang",
  "订单号": "Nomor Pesanan",
  "充值金额": "Jumlah Pengisian Ulang",
  "充值方式": "Metode Pengisian Ulang",
  "地位": "Status",

  '负责任的博彩': 'Permainan Bertanggung Jawab',
  '快速链接': 'Tautan Cepat',
  '桌上游戏': 'Permainan Meja',
  '二十一点': 'Blackjack',
  '扑克': 'Poker',
  '百家乐': 'Baccarat',
  '掷骰子': 'Dadu',
  '奖金': 'Bonus',
  '赌场奖金': 'Bonus Kasino',
  '自由旋转': 'Putaran Gratis',
  '免费投注': 'Taruhan Gratis',
  '信息': 'Informasi',
  "":"",
  
	"老虎机游戏": "Permainan Slot",
  "赌场游戏": "Permainan Kasino",
  "更多游戏": "Lebih Banyak Permainan",
  "搜索游戏": "Cari Permainan",
  "特色提供商": "Penyedia Unggulan",
  "Logout": "Keluar",
  "Personal Center": "Pusat Pribadi",
  "Limit": "Batas",
  "MessageCenter": "Pusat Pesan",

  'All': 'Semua',
  'Arcade': 'Arkade',
  'Bingo': 'Bingo',
  'Card': 'Kartu',
  'Casino': 'Kasino',
  'Crash': 'Crash',
  'Fish': 'Ikan',
  'Live': 'Langsung',
  'Lottery': 'Lotere',
  'Slot': 'Slot',
  'Sports': 'Olahraga',
  'Video Game': 'Permainan Video',

  'cs-title': '24 JAM',
  'cs-text': 'Layanan pelanggan tersedia untuk pemecahan masalah dan pertanyaan.',
  'cs-contact': 'Kontak',

  'social-media': 'Media Sosial',
  'contact-us': 'Hubungi kami melalui yang berikut',

  'footer-line1': 'dioperasikan oleh',
  'footer-line2': 'Alamat perusahaan terdaftar',
  'footer-line3': 'Produk ini hanya untuk pengguna berusia di atas 18 tahun dan hanya untuk tujuan hiburan',
  'footer-line4': 'Permainan ini berisi pembelian dalam aplikasi',
  'footer-line5': 'Fakta bahwa seorang pemain bermain atau menang dalam perjudian sosial tidak berarti bahwa dia akan menang dalam perjudian uang sungguhan dan permainan terkait di masa depan',

  // Added Lines

  'popup-message': 'Apakah Anda ingin mematikan pengingat?',

  'sign-in': 'Masuk',
  'password': 'Kata Sandi',
  'confirm-password': 'Konfirmasi Kata Sandi',
  'remember-me': 'Ingat Saya',
  'forgot-password': 'Lupa Kata Sandi',
  "sign-in-note": "Belum punya akun?",
  "register-note": "Sudah punya akun?",
  "register": "Daftar",

  "popular": "Populer",
  "promotion": "Promosi",
  "follow": "Ikuti",
  'search': 'Cari',

  'home': 'Beranda',
  'deposit': 'Setoran',
  'withdraw': 'Tarik',
  'profile': 'Profil',
  'online-cs': 'Layanan Pelanggan Online',

  "search-games": "Cari Permainan",
  "search-results": "Hasil Pencarian",

  'Activity': 'Kegiatan',
  'Rebates': 'Rebate',
  'VIP': 'VIP',
  'History': 'Riwayat',
  'Cover': 'Sampul',

  'recharge-activity': 'Kegiatan Pengisian Ulang',
  'time': 'Waktu',
  'reward': 'Hadiah',
  'deposit-value': 'Nilai Setoran',
  'status': 'Status',
  'reward-bonus-discription': "Dapatkan 10R$ secara gratis setelah setoran pertama Anda sebesar 100R$.",
  'invitaion-activity-discription': "Undang teman dan dapatkan 100R$ secara gratis.",
  'daily-loss-activity-discription': "Cashback Harian 8%",
  'recharge-rebet-activity-discription': "Dapatkan cashback 20% secara gratis saat Anda mengisi ulang 100R$ dalam satu transaksi",
  'user-not-eligible': "Anda tidak memenuhi syarat untuk hadiah ini",
  '不符合领取资格': "Tidak memenuhi syarat untuk diterima",
  'reward-claimed': "Hadiah berhasil diklaim!",
  '没有符合资格的充值': 'Tidak ada pengisian ulang yang memenuhi syarat',

  'invitation-activity': 'Kegiatan Undangan',
  'recharge-amount': 'Jumlah Pengisian Ulang',
  'spin': 'Putar',
  'bonus': 'Bonus',
  'invites': 'Undangan',
  "install-btn": "PASANG",

  'daily-loss-relief-fund': 'Dana Bantuan Kerugian Harian',
  'percent': 'Persen',
  "amount-loss": "Jumlah Kerugian",

  'recharge-rebate-activity': 'Kegiatan Rebate Pengisian Ulang<br>',
  'recharge-amount': 'Jumlah pengisian ulang',
  'return-ratio': 'Rasio Pengembalian',
  'return-amount': 'Jumlah Pengembalian',

  'recharge-note1': 'Pengisian ulang tunggal sebesar 100 real Brasil dapat berpartisipasi dalam acara ini',
  'recharge-note2': 'Setiap pengisian ulang sebesar 100 real Brasil atau lebih dihitung secara independen;',
  'recharge-note3': 'Kegiatan ini memerlukan minimal 5 kali jumlah pengisian ulang untuk menerima hadiah;',
  'recharge-note4': 'Mereka yang tidak memenuhi standar atau menyelesaikan pengumpulan hadiah setelah acara tidak akan dapat menerima hadiah lagi;',
  'recharge-note5': 'Kegagalan untuk menghindari kerugian, silakan selesaikan tugas sebelumnya atau terima hadiah;',
  'recharge-note6': 'Kegiatan ini dibatasi pada perilaku operasi normal pemegang akun dan melarang cara teknis seperti menyewa, curang, bot, bermain game dengan akun yang berbeda, saling menyemprot, arbitrasi, antarmuka, protokol, mengeksploitasi kerentanan, dan kontrol grup. Jika tidak, hadiah akan dibatalkan, dikurangi, dibekukan, atau bahkan dimasukkan dalam daftar hitam;',
  'recharge-note7': 'Hak interpretasi semua kegiatan akhirnya dimiliki oleh platform ini;',

  'claim': 'Klaim',

  'lottery-wheel': 'Roda Lotere',
  'number-of-spin': 'Jumlah Putaran',
  'spin': 'Putar',

  'upgrade-required': 'Peningkatan diperlukan',
  'recharge': 'Pengisian Ulang',
  'betting': 'Taruhan',
  'Bonus': 'Bonus',
  'Notification': 'Notifikasi',
  'Announcement': 'Pengumuman',
  'Support': 'Dukungan',
  'level': 'Tingkat',

  'view-data': 'Lihat data',
  'current-data': 'Data saat ini',
  'last': 'Terakhir',
  'days': 'hari',
  'event': 'Acara',
  'notes': 'Catatan',

  'rebate-funds': 'Dana Rebate',
  'statement': 'Pernyataan',
  'rebate': 'Rebate',

  'platform-rebate': 'Rebate Platform',
  'action': 'Tindakan',
  'type': 'Jenis',
  'amount': 'Jumlah',

  'record': 'Rekaman',
  'recharge-method': 'Metode Pengisian Ulang',
  'recharge-note': 'Jika Anda mengalami masalah, silakan hubungi kami!',
  'withdrawal-note': 'Jika Anda mengalami masalah, silakan hubungi kami!',
  'online-service': 'Layanan Online',
  'recharge-amount': 'Jumlah Pengisian Ulang',
  'withdrawal': 'Penarikan',
  'online-withdrawal': 'Penarikan Online',
  'withdrawal-method': 'Metode Penarikan',
  'fee': 'Biaya',
  'full-name': 'Nama Lengkap',
  'please-enter-your': 'Silakan masukkan',
  'name': 'Nama',
  'collection-account-number': 'Nomor akun pengumpulan',
  'withdraw-password': 'Kata Sandi Penarikan',
  'phone-number': 'Nomor Telepon',
  'security-center': 'Pusat Keamanan',
  'change-password': 'Ubah Kata Sandi',
  'financial-status': 'Status Keuangan',
  'verify-password': 'Verifikasi Kata Sandi',
  'bind-email-note': 'Anda mengikat email Anda dan perlu memverifikasi kata sandi login Anda',
  'bind-password-note': 'Anda mengubah kata sandi Anda dan perlu login untuk verifikasi kata sandi',
  'next-step': 'Langkah Selanjutnya',

  'balance': 'Saldo',
  'information-center': 'Pusat Informasi',
  'order-center': 'Pusat Pesanan',
  'agency-center': 'Pusat Agensi',
  'exit': 'Keluar',
  'bonus-amount': 'Jumlah Bonus',
  'fee-amount': 'Jumlah Biaya',
  'change': 'Ubah',
  'male': 'Pria',
  'female': 'Wanita',
  'submit': 'Kirim',
  'information': 'Informasi',
  'Details': 'Detail',
  'Fee': 'Biaya',
  'Association': 'Asosiasi',

  'Invite': 'Undang',
  'Agent': 'Agen',
  'Invitation record': 'Rekaman Undangan',
  'Invitation': 'Undangan',
  'Reward': 'Hadiah',
  'Agency mechanism': 'Mekanisme Agensi',
  'Register subordinates': 'Daftar bawahan',
  'my-id': 'ID Saya',
  'inviter-id': 'ID Pengundang',
  'ordinary-agent': 'Agen Biasa',
  'my-invitation-information': 'Informasi undangan saya',
  'my-links': 'Tautan saya',
  'save-qr-code': 'Simpan Kode QR',
  'my-invitation-record': 'Rekaman undangan saya',
  'total-number-of-invited-people': 'Total jumlah orang yang diundang',
  'direct-reports': 'Laporan Langsung',
  'invitation-rewards': 'Hadiah undangan',
  'invitation-total-reward': 'Total hadiah undangan',
  'directly-invite-rewards': 'Hadiah undangan langsung',
  'indirect-invitation-reward': 'Hadiah undangan tidak langsung',
  'more': 'Lebih',

  'invitation-total': 'Total undangan',
  'direct-rewards': 'Hadiah langsung',
  'indirect-incentives': 'Insentif tidak langsung',
  'no-agent': 'Tidak ada agen untuk ditampilkan',
  "no-record": "Tidak ada rekaman yang ditemukan",
  "no-more-roll": "Tidak ada lagi gulungan yang tersisa",
  'rebate-ration': 'Rasio Rebate',
  'deposit-value': 'Nilai Setoran',

  'bet-on': 'Taruhan pada',
  'settlement': 'Penyelesaian',
  'consumption': 'Konsumsi',
  'agent-text': 'Teks Agen',
  'reg-sub-text': "Setelah menyelesaikan pendaftaran, masukkan nomor telepon terdaftar undangan, kode undangan, dan UID mereka untuk mengikatnya.",
  'your-invitation-code': 'Kode undangan Anda',
  'UID-of-the-invitee': 'UID dari yang diundang',
  'user-does-not-exist': 'PENGGUNA TIDAK ADA',

  'no-record': 'Tidak ada rekaman yang ditemukan',
  'reg-success': 'Pendaftaran Anda telah berhasil diselesaikan',
  'reg-failed': 'Pendaftaran Gagal',
  'valid-number': 'Silakan masukkan nomor telepon seluler yang valid',
  'valid-pass2': 'Kata sandi tidak cocok',
  'pass-error': 'Kata sandi harus setidaknya 6 karakter',
  "network-error": "Kesalahan jaringan, silakan coba lagi nanti",
  'fix-error': 'Silakan perbaiki kesalahan di formulir',

  'invalid_phone': 'Silakan masukkan nomor telepon seluler yang benar.'
}
export default id



// WEBPACK FOOTER //
// ./src/utils/lang/config/id.js